export default "/images/cn_foods_provided_sm.jpg?db1c7675d88b6d6aaa65fc710097994e";